import Loading from './Loading.view';

export default Loading;
